import { useEffect } from "react";

import { makeStyles, Grid, Box, Typography } from "@material-ui/core";

import { DialogBox } from "../../../../components/boxes";
import { Icon, Dialog } from "../../../../components/base";
import SuccessIcon from "../../../../assets/images/icons/success-icon.svg";

const useStyles = makeStyles(() => ({
  root: {
    width: 520,
    height: 386,
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 80,
    height: 80,
    borderRadius: "100%",
    backgroundColor: "#E7FCDC",
  },
  typography: {
    maxWidth: 273,
    textAlign: "center",
    marginTop: 10,
  },
}));

export const NewPowerAssetsSuccessModal = ({ isOpen, setOpen }) => {
  const classes = useStyles();

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setOpen(false), 2000);
    }
  }, [isOpen, setOpen]);

  return (
    <Dialog isOpen={isOpen} onClose={() => setOpen(false)}>
      <DialogBox>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          className={classes.root}
          direction="column"
        >
          <Box className={classes.icon}>
            <Icon src={SuccessIcon} />
          </Box>
          <Box className={classes.typography}>
            <Typography variant="h4">
              Here comes success message + guidlines for next steps
            </Typography>
          </Box>
        </Grid>
      </DialogBox>
    </Dialog>
  );
};
